<template>
   <div class="mx-2  pt-2 ">
            <div class="flex justify-between mt-10 md:mt-0 items-baseline	">
                <h1 style="font-weight: 550;" class="text-2xl  mb-5 md:mt-10 mt-3">Roles</h1>
                <!-- v-if="hasCnaCreateUser" -->
                <router-link v-if="hasCnaCreateRole" to="/createrole" style="background: #2E2C72;"
                    class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 md:px-5 md:py-2.5 dark:bg-regal-blue dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">Create
                    Role
                </router-link>
            </div>
            <div class="flex flex-column sm:flex-row flex-wrap space-y-4 sm:space-y-0 items-center justify-between  pb-4">
                <div>
             
                    <span class="text-base">
                        show:
                        <select @change="fetchrole('isshowuser')" v-model="number" class="rounded-lg" id="quantity"
                            name="quantity" style="border: 1px solid white; border-top: #F9F9F9;">
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                        </select>
                        &nbsp; entries
                    </span>
                </div>
                <form>
                    <label for="default-search"
                        class="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white">Search</label>
                    <div class="relative">
                        <input type="search" v-model="searchQuery"  style="padding-left: 20px; width: 350px; "
                            id="default-search"
                            class="block w-full p-4 pl-10 ps-20 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="Search" required>
                        <button type="button" 
                        @click.prevent="handlesearch" 
                            class="text-white bg-button-blue absolute end-2.5 bottom-2  hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-[10px] py-[12px] dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                            <svg style="" class="w-10 h-4  text-white dark:text-gray-400" aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                            </svg></button>
                    </div>
                </form>
            </div>
            <div class="relative overflow-x-auto overflow-hidden  shadow-md ">
                <table class="w-full text-sm  border text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead class="text-xs text-gray-700  bg-stone-300 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                            <th scope="col" class="px-6 py-3">
                                Id
                            </th>
                            <th scope="col" class="px-6 py-3">
                                <div class="flex items-center">
                              Role Name
                                </div>
                            </th>
                            <th scope="col" class="px-6 py-3">
                                <div class="flex items-center">
                                    Session Time
                                </div>
                            </th>
                            <th scope="col" class="px-6 py-3">
                                <div class="flex items-center">
                                    Permissions
                                </div>
                            </th>
                            <!-- v-if="hascanupdateuser" -->
                            <th scope="col" class="px-6 py-3" v-if="hascanupdateroler" >
                                <span class="flex items-center " >Edit</span>
                            </th>
                            <!-- v-if="hascandeleteuser" -->
                            <!-- <th scope="col" class="px-6 py-3" >
                                <span class="flex items-center" >Delete</span>
                            </th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="role in roles" :key="role.id"
                            class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                            <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{{ role.id }}
                            </td>
                            <td class="px-6 py-4">{{ role?.name }}</td>
                            <td class="px-6 py-4">{{ role?.session_time }}</td>
                            <td class="px-6 py-4" >  <span class="bg-green-100 text-green-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-green-900 dark:text-green-300">{{ role.permissions.map(rol => rol?.name).join(', ') }}</span></td>
                      
                             <td class="px-6 py-4 " >
                                <router-link v-if="hascanupdateroler"  :to="'/updaterole-' + role.id"
                                    class="font-medium text-blue-600 dark:text-blue-500 hover:underline">Edit</router-link>
                            </td>
                            <!-- <td class="px-6 py-4 "  style="cursor: pointer;">
                                <a  @click="delteuser(role.id)" style="color: red;"
                                    class="font-medium text-blue-600 dark:text-blue-500 hover:underline">Delete</a>
                            </td>  -->
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="flex justify-end mt-2">
                <vue-awesome-paginate :total-items="totalpage" class="overflow-hidden pl-5" :items-per-page="1"
                    :max-pages-shown="5" v-model="currentPage" :on-click="onClickHandler" :hide-prev-next-when-ends="true"
                    next-button-content=">" />
            </div>
        </div>
</template>
<script setup>
import { ref, watch, computed, onMounted, onUnmounted } from 'vue';
import axiosInstance from "@/plugins/axios"
import Swal from 'sweetalert2';
const roles = ref()
// const chunk = ref(1)
const number = ref(10)
const currentPage = ref(1);
const totalpage = ref()
const searchQuery = ref('');


const handlesearch = async (e) => {
    await fetchrole('isshowuser');
}
const fetchrole = async (isshowuser) => {
    try {
        if (isshowuser === 'isshowuser') {
            currentPage.value = 1
            const response = await axiosInstance.get(`/get-roles/${number.value}/${searchQuery.value}/?page=${currentPage.value}`);
            roles.value = response.data.data.roles.data
            totalpage.value = response.data.data.roles.last_page;
        } else {
            const response = await axiosInstance.get(`/get-roles/${number.value}/?page=${currentPage.value}`);
            roles.value = response.data.data.roles.data
            totalpage.value = response.data.data.roles.last_page;
        }

    } catch (error) {
        console.error('Error fetching district info:', error);
        // Handle error or show error message
    }
}
const onClickHandler =  () => {
     fetchrole()
    // pagniationpage.value =  true
}
const delteuser = async (id) => {
    const confirmed = await Swal.fire({
        title: 'Are you sure?',
        text: 'You want to delete this shift?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
    });
    const response = await axiosInstance.delete(`/users/${id}`);

    if (confirmed.isConfirmed) {
        try {
           
            Swal.fire(
                'Deleted!',
                'Your user has been deleted.',
                'success'
            );
            fetchrole()
        } catch (error) {
            console.error('Failed to delete user:', error);
            Swal.fire(
                'Error!',
                'Failed to delete user.',
                'error'
            );
        }
    }
};
import { useAuthService } from '@/store/Auth'; //  auth.js file
const authStore = useAuthService();
const permissions = ref([])
onMounted(() => {
  const authData = authStore.authData;
  permissions.value = authStore.authData.permissions

});
const hasCnaCreateRole = computed(() => permissions.value.some(permission => permission.name === 'can create role'));
const hascanupdateroler = computed(() => permissions.value.some(permission => permission.name === 'can update role'));
const hascandeleteuser = computed(() => permissions.value.some(permission => permission.name === 'can delete role'));

onMounted(async()=>{
  await authStore.handlepermission()
})

onUnmounted(async()=>{
  await authStore.handlepermission()
})
onMounted(() => {
    fetchrole()
})
</script>